// src/pages/Vacancies.jsx
import React from 'react';
export default function Vacancies(){
  return (
    <main className="container" style={{ padding:'16px 0' }}>
      <h2>Vacancies</h2><p>Просто страница с текстом — Ваш Текст.</p>
    </main>
  );
}
